import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="hccbt-container section text-center" data-testid="not-found-page">
    <span className="overline">404</span>
    <h1 className="font-display text-5xl mt-4 text-[#0F172A]">Page not found</h1>
    <p className="mt-4 text-[#475569]">The page you're looking for doesn't exist or has moved.</p>
    <Link to="/" className="btn-primary mt-8 inline-flex">Back to home</Link>
  </div>
);

export default NotFound;
